import { render, staticRenderFns } from "./TokenBlock.vue?vue&type=template&id=c454505e&"
import script from "./TokenBlock.vue?vue&type=script&lang=ts&"
export * from "./TokenBlock.vue?vue&type=script&lang=ts&"
import style0 from "./TokenBlock.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports